// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Xmyb","inputWrap":"Table_inputWrap__3q1di","col":"Table_col__1vTTF","bmiTooltip":"Table_bmiTooltip__2vcfx"};